import { createSlice } from "@reduxjs/toolkit";
import Cookies from 'universal-cookie';
import { RootState } from "./store";
import TokenData from "../../models/TokenData";
import LoggedUser from "../../models/LoggedUser";

interface AuthState {
  userToken: string | null;
  tokenData: TokenData | null;
  loggedUser: LoggedUser | null;
  isSignedIn: boolean;
  hasCtEyeDevices: boolean;
}

const initialState: AuthState = {
  userToken: null,
  tokenData: null,
  loggedUser: null,
  isSignedIn: false,
  hasCtEyeDevices: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.userToken = action.payload;
    },
    clearToken: (state) => {
      state.userToken = null;
    },
    setTokenData: (state, action) => {
      state.tokenData = action.payload;
      // Add the token to cookies, for direct browser requests
      const apiDomain = new URL(process.env.REACT_APP_API_URL ?? document.location.href);
      (new Cookies()).set('Jwt', action.payload, {
        path: '/',
        domain: apiDomain.hostname
      });
    },
    clearTokenData: (state) => {
      state.tokenData = null;
      // Clear the token from cookies as well
      (new Cookies()).remove('Jwt');
    },
    setLoggedUser: (state, action) => {
      state.loggedUser = action.payload;
    },
    clearLoggedUser: (state) => {
      state.loggedUser = null;
    },
    setIsLoggedIn: (state, action) => {
      state.isSignedIn = action.payload;
    },
    setHasCtEyeDevices: (state, action) => {
      state.hasCtEyeDevices = action.payload;
    },
  },
});

export const {
  setToken, clearToken,
  setTokenData, clearTokenData,
  setLoggedUser, clearLoggedUser,
  setIsLoggedIn,
  setHasCtEyeDevices
} = authSlice.actions;
export const getUserToken = () => (state: RootState) => state.auth.userToken;
export default authSlice.reducer;
